import React, { useEffect, useState, useMemo } from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { useLocation,  useNavigate } from "react-router-dom";
import { logout } from "../../service/ApiService";

interface Route {
  path: string;
  url: string;
  breadcrumbName: string;
}
const BreadcrumbsComponent = () => {
  const [activePath, setActivePath] = useState<string>("/actionsView");
  const location = useLocation();
  const navigate = useNavigate();

  const routes: Route[] = useMemo(() => [
    { path: "/featuresView", breadcrumbName: "Features", url: "/featuresView" },
    { path: "/flowsView", breadcrumbName: "Flows", url: "/flowsView" },
    { path: "/actionsView", breadcrumbName: "Actions", url: "/actionsView" },
  ], []);

  useEffect(() => {
    if (location.pathname) {
      setActivePath(location.pathname);
    }
  }, [location]);

  const handleLogout = async () => {
    // Only the server can clear an HttpOnly cookie, so the session ends there.
    try {
      await logout();
    } finally {
      navigate('/login');
    }
  };

  const getUpdatedRoutes = (currentPath: string): Route[] => {
    return routes.map((item) => {
      if (currentPath === "/actionsView" && (item.path === "/flowsView" || item.path === "/actionsView")) {
        if (item.path === "/flowsView") {
          const queryString = location.search;
          const params = new URLSearchParams(queryString);
          params.delete("flowId");
          const updatedQueryString = params.toString();
          return { ...item, url: `/flowsView?${updatedQueryString}` };
        } else {
          return { ...item, url: `${currentPath}${location.search}` };
        }
      }
      return item;
    });
  };

  const updatedRoutes = useMemo(() => getUpdatedRoutes(activePath), [activePath, location.search]);

  return (
    <>   
    <div className="flex justify-end pr-5 py-3">
  <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full" onClick={handleLogout}>
    Logout
  </button>
</div>
    <div className={`container mx-auto ${activePath == "/featuresView" ? "" : "pb-3"}`}>
      {activePath !== "/featuresView" && (
        <Breadcrumbs aria-label="breadcrumb">
          {updatedRoutes.map((item, index) => (
            <div key={index}>
              {activePath === item.path ? (
                <Typography color="textPrimary">
                  {item.breadcrumbName}
                </Typography>
              ) : (
                <Link
                  underline="hover"
                  href={item.url}
                  color={"inherit"}
                  onClick={() => setActivePath(item.path)}
                >
                  {item.breadcrumbName}
                </Link>
              )}
            </div>
          ))}
        </Breadcrumbs>
      )}
    </div>
    </>
  );
};

export default BreadcrumbsComponent;
